export default __webpack_public_path__ + "static/media/pending.2a934fce.svg";